export function checkStateFulfillment(stateSpec: StateSpec, interactionState: Record<string, boolean>): boolean {
  for (const state in stateSpec) {
    if (!!stateSpec[state] !== !!interactionState[state]) {
      return false;
    }
  }
  return true;
}